module.exports = __webpack_public_path__ + "img/Satisfaction@3x.20c98d60.png";